import { render } from "./HeaderButton.vue?vue&type=template&id=6a8c4173&ts=true"
import script from "./HeaderButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./HeaderButton.vue?vue&type=script&lang=ts&setup=true"

import "./HeaderButton.vue?vue&type=style&index=0&id=6a8c4173&lang=less"

import exportComponent from "/src/PortalSite/Portal/ClientApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vuecomponents/layout/HeaderButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6a8c4173"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6a8c4173', __exports__)) {
    api.reload('6a8c4173', __exports__)
  }
  
  module.hot.accept("./HeaderButton.vue?vue&type=template&id=6a8c4173&ts=true", () => {
    api.rerender('6a8c4173', render)
  })

}


export default __exports__